import ClockIcon from 'components/elements/icons/ClockIcon'
import InformationContent from 'components/elements/items/InformationContent'
import RequestedTemplate from 'components/templates/RequestedTemplate'
import dayjs from 'dayjs'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { toFullWidthString } from 'utils/commonUtils'
import { useExitWebSocket } from 'utils/websocket'

/**
 * QN-08-a: 予約完了画面
 */
const Reserved: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state } = props
  const { date: reservedDate, time: reservedTime } = props.state.reservation
  useExitWebSocket(true)

  /** 選択した予約日 */
  const selectedDate: dayjs.Dayjs = React.useMemo(() => {
    return dayjs(`${reservedDate} ${reservedTime} `)
  }, [reservedDate, reservedTime])

  /** 指定のフォーマット(MM/dd (ddd))に変換した予約日の文字列 */
  const reservationDate = React.useMemo(() => {
    return toFullWidthString(
      `${
        selectedDate.month() + 1
      }／${selectedDate.date()}（${selectedDate.format('ddd')}）`
    )
  }, [selectedDate])

  /** 指定のフォーマット(H時～H時)に変換した予約時間の文字列 */
  const reservationTime = React.useMemo(() => {
    const reservationEndTime = dayjs(selectedDate).add(2, 'hour')
    return `${toFullWidthString(
      `${selectedDate.format('H時')}～${reservationEndTime.format('H時')}`
    )}`
  }, [selectedDate])

  return (
    <RequestedTemplate
      title={'予約完了画面'}
      content={
        <InformationContent
          items={[
            {
              icon: <ClockIcon />,
              marginBottom: '20px',
            },
            {
              message: '予約を受け付けました',
              large: true,
            },
            {
              message: `${reservationDate}${reservationTime}`,
              small: true,
            },
            {
              message: '詳細な到着時間は対応スタッフから\nご連絡いたします。',
              small: true,
            },
          ]}
        />
      }
      state={state}
    />
  )
}

export default Reserved
